import React, {
  useEffect,
  useState,
} from "react";

import { useParams } from "react-router-dom";

import {useAppDispatch,useAppSelector} from "../../../app/hooks";

import ManagementModal from "../../../components/ui/modals/ManagementModal";
import AssetForm from "./AssetForm";

import { AssetFields} from "../../../api/assets";

import { updateAsset } from "../Logic/assetsThunk";

import {selectAssetById} from "../Logic/assetsSlice";

import {showErrorToast,showSuccessToast} from "../../../lib/toast";

interface EditAssetModalProps {
  assetId: string;
  onClose: () => void;
  onBack: () => void;
}

const EditAssetModal: React.FC<
  EditAssetModalProps
> = ({
  assetId,
  onClose,
  onBack,
}) => {
  const dispatch = useAppDispatch();

  const { id: case_id } = useParams<{ id: string }>();

  const asset = useAppSelector( state =>selectAssetById(state,assetId));

  const [isSaving, setIsSaving] =useState(false);

  const [values, setValues] =
    useState<Partial<AssetFields>>({
      asset_class: undefined,
      asset_type: undefined,
      ext_asset_id: "",
      asset_name: "",
    });

  useEffect(() => {
    if (!asset) return;

    setValues({
      asset_class: asset.asset_class,
      asset_type: asset.asset_type,
      ext_asset_id:asset.ext_asset_id,
      asset_name: asset.asset_name,
    });
  }, [asset]);

  const handleSubmit =
    async () => {
      if (!case_id) {
        showErrorToast("Case ID not found");
        return;
      }

      setIsSaving(true);

      try {
        await dispatch(
          updateAsset({
            case_id,
            asset_id: assetId,
            request: {
              ext_asset_id: values.ext_asset_id,
              asset_name: values.asset_name,
            },
          }),
        ).unwrap();

        showSuccessToast("Asset updated successfully");

        onClose();
      } catch (error) {
        showErrorToast("Failed to update asset");
      } finally {
        setIsSaving(false);
      }
    };

  const isSubmitEnabled =!!values.ext_asset_id?.trim() && !isSaving;  

  return (
    <ManagementModal
      title="Edit Asset"
      submitLabel="Save"
      onSubmit={handleSubmit}
      onBack={onBack}
      onClose={onClose}
      submitEnabled={isSubmitEnabled}
      isLoading={isSaving}
    >
      <AssetForm
        values={values}
        onValuesChange={setValues}
        isEditMode
      />
    </ManagementModal>
  );
};

export default EditAssetModal;